import { create } from 'zustand';
import { MediaItem } from '@/types/posts';

interface PostCreatorStoreState {
  isOpen: boolean;
  initialCaption: string;
  editingPostId: number | undefined;
  initialMedia: MediaItem[] | undefined;
  initialScheduleOpen: boolean;
}

interface PostCreatorStoreActions {
  open: (params?: { initialCaption?: string; editingPostId?: number; initialMedia?: MediaItem[]; initialScheduleOpen?: boolean }) => void;
  close: () => void;
}

type PostCreatorStore = PostCreatorStoreState & PostCreatorStoreActions;

export const usePostCreatorStore = create<PostCreatorStore>((set) => ({
  isOpen: false,
  initialCaption: '',
  editingPostId: undefined,
  initialMedia: undefined,
  initialScheduleOpen: false,
  open: (params) =>
    set({
      isOpen: true,
      initialCaption: params?.initialCaption ?? '',
      editingPostId: params?.editingPostId,
      initialMedia: params?.initialMedia,
      initialScheduleOpen: params?.initialScheduleOpen ?? false,
    }),
  close: () =>
    set({
      isOpen: false,
      initialCaption: '',
      editingPostId: undefined,
      initialMedia: undefined,
      initialScheduleOpen: false,
    }),
}));
